import gql from 'graphql-tag';

export function getFieldRegionReportWithApplicationStats(
  fieldUUID: string,
  seasonTag: string,
  geometry: unknown
) {
  const commonFields = `
    averageYield {
      ...reportMeasurementFragment
    }
    averageMoisture {
      ...reportMeasurementFragment
    }
    acres
    area {
      ...reportMeasurementFragment
    }
    totalWeight {
      ...reportMeasurementFragment
    }
  `;

  return {
    query: gql`
    fragment reportMeasurementFragment on ConvertedValueUnit {
      u
      v
    }
    fragment statsSecondDepthFragment on FieldRegionReportStatsSecondDepth {
      label
      ${commonFields}
    }
    fragment statsFragment on FieldRegionReportStats {
      label
      ${commonFields}
      soilStats {
        ...statsSecondDepthFragment
      }
      hybridStats {
        ...statsSecondDepthFragment
      }
      seedTreatmentStats {
        ...statsSecondDepthFragment
      }
      elevationStats {
        ...statsSecondDepthFragment
      }
      populationStats {
        ...statsSecondDepthFragment
      }
      planterDateStats {
        ...statsSecondDepthFragment
      }
    }
    fragment fieldRegionReportFragment on FieldRegionReport {
      ${commonFields}
    }
    query fieldRegionReport(
        $fieldUUID: String,
        $seasonTag: String,
        $geometry: GeometryInput,
      ) {
      reports {
        fieldRegionReport(
          fieldUUID: $fieldUUID,
          seasonTag: $seasonTag,
          geometry: $geometry,
          includeApplication: true
        ) {
          ...fieldRegionReportFragment
          soilStats {
            ...statsFragment
          }
          hybridStats {
            ...statsFragment
          }
          seedTreatmentStats {
            ...statsFragment
          }
          elevationStats {
            ...statsFragment
          }
          populationStats {
            ...statsFragment
          }
          planterDateStats {
            ...statsFragment
          }
          populationUnits
          applicationStats {
            applicationPassName
            dateApplied
            products
            appliedYield {
              averageMoisture {
                v
                u
              }
              averageYield {
                v
                u
              }
              area {
                v
                u
              }
            }
            unappliedYield {
              averageMoisture {
                v
                u
              }
              averageYield {
                v
                u
              }
              area {
                v
                u
              }
            }
          }
          hybridColors {
            label
            color
          }
        }
      }
    }`,
    variables: {
      fieldUUID,
      seasonTag,
      geometry
    },
  };
}
